window.changeDomainContext = (domainID) => {
    const url = location.protocol + '//' + location.host + location.pathname;
    console.log(domainID)
    if (domainID) {
        window.location.href = `${url}?_selected_domain=${domainID}`;
        return;
    }
   window.location.href = `${url}?_selected_domain=`;
}